import React from "react";
import { Button, Form } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./LoanApplicationFooter.css";

const LoanApplicationFooter = ({
    onBack,
    onSubmit,
    onSaveNext,
    backButtonText = "Go Back",
    submitButtonText = "Save And Proceed",
    submitDisabled = false,
    showBackButton = true,
    showSubmitButton = true,
    isSubmitButton = true
}) => {
    return (
       
            <div className="loan-application-footer" style={{ marginBottom: 0 }}>
                {showBackButton && (
                    <Button onClick={onBack} icon={<LeftOutlined />} size="large">
                        {backButtonText}
                    </Button>
                )}

                {showSubmitButton && (
                    <Button
                        type="primary"
                        htmlType={isSubmitButton ? "submit" : "button"}
                        onClick={!isSubmitButton ? onSubmit : onSaveNext}
                        size="large"
                        disabled={submitDisabled}
                    >
                        {submitButtonText} <RightOutlined />
                    </Button>
                )}
            </div>
        
    );
};

export default LoanApplicationFooter;
